import * as Sentry from '@sentry/vue'
// eslint-ignore

// @ts-nocheck - third party script
export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp

  Sentry.init({
    app: vueApp,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_GIT_SHA,
    environment: import.meta.env.VITE_ENV,
    tracesSampleRate: import.meta.env.VITE_ENV === 'prod' ? 0.5 : 1.0,
    logErrors: true,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // set this to true if you need to track errors in development
    enabled: ['test', 'stage', 'prod'].includes(process.env.MODE ?? ''),
  })
})
